var render, staticRenderFns
import script from "./NoticeTips.vue?vue&type=script&lang=js&"
export * from "./NoticeTips.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTips.vue?vue&type=style&index=0&id=35e80807&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e80807",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35e80807')) {
      api.createRecord('35e80807', component.options)
    } else {
      api.reload('35e80807', component.options)
    }
    
  }
}
component.options.__file = "src/components/Tips/NoticeTips.vue"
export default component.exports